import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesAssignResourceColumnsModel} from "../../models/services-assign-resource-columns.model";

export class ServicesAssignResourceAllocationTableCtrl implements IController {
  list: any[] = [];
  extraVolume: any;
  selectedResourceAllocationData: any;
  loading: any;
  columns: ServicesAssignResourceColumnsModel;
  searchQuery: any;
  hideUnroutedResources: boolean;
  onResourceAllocationSelected: Function;
  onAttachedVehicleChanged: Function;
  onMainVehicleChanged: Function;

  public hasLogisticsVehiclePermission: boolean;
  public isScrollable: boolean;
  public filteredList: any[] = [];

  constructor(private IAMPermissions) {
    this.hasLogisticsVehiclePermission = this.IAMPermissions.hasPermission('vehicleInstance.logisticsVehicle.list');
  }

  $onInit() { }

  $onChanges(changes) {
    if (changes.list || changes.searchQuery || changes.hideUnroutedResources) {
      this._updateFilteredList();
    }
  }

  // $doCheck() {
  //   const numOfColumns = _.reduce(this.columns, (sum, column) => {
  //     return sum += column.enabled ? 1 : 0;
  //   }, 0);
  //
  //   this.isScrollable = numOfColumns > 10 || _.isUndefined(this.columns) ? true : !this.$mdMedia('gt-md');
  // }

  private _updateFilteredList() {
    if (!this.list) {
      this.filteredList = [];
      return;
    }

    this.filteredList = this.list.filter(this._filterResource.bind(this));
  }

  private _filterResource(resourceAllocation) {
    const searchQuery = (this.searchQuery || '').toLowerCase();

    return (!this.hideUnroutedResources || !!resourceAllocation.route) && (!searchQuery
      || (_.get(resourceAllocation.supplyResource, 'name', '').toLowerCase().indexOf(searchQuery) !== -1)
      || (_.get(resourceAllocation.route, 'agentReference.firstName', '').toLowerCase().indexOf(searchQuery) !== -1)
      || (_.get(resourceAllocation.route, 'agentReference.lastName', '').toLowerCase().indexOf(searchQuery) !== -1)
      || (_.get(resourceAllocation.route, 'id', '').toLowerCase().indexOf(searchQuery) !== -1)
      || (_.get(resourceAllocation.supplyResource, 'agentReference.firstName', '').toLowerCase().indexOf(searchQuery) !== -1)
      || (_.get(resourceAllocation.supplyResource, 'agentReference.lastName', '').toLowerCase().indexOf(searchQuery) !== -1));
  }

  setEvents() {
    const div1 = document.getElementById('services-assign-resource-allocation-table').querySelectorAll("#header")[0];
    const div2 = document.getElementById('services-assign-resource-allocation-table').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesAssignResourceAllocationTable', {
    bindings: {
      list: '<',
      extraVolume: '<?',
      selectedResourceAllocationData: '<?',
      loading: '<?',
      searchQuery: '<',
      hideUnroutedResources: '<?',
      onResourceAllocationSelected: '&',
      onAttachedVehicleChanged: '&',
      columns: '<',
      onMainVehicleChanged: '&'
    },
    template: require('./services-assign-resource-allocation-table.html').default,
    controller: ServicesAssignResourceAllocationTableCtrl
  });
